import { ContractualizationResponseDto } from 'api/quote';
import { QuoteContractualizationData } from '../types/contractualizationData';

/**
 * Transforme le DTO Quote API en QuoteContractualizationData
 * Utilise lors du fetch initial dans SubscriptionProcessProvider
 */
export const mapQuoteResponseToData = (
  dto: ContractualizationResponseDto,
  riskId: string,
  folderIdentifier: string,
  branchCode?: string
): QuoteContractualizationData => {
  return {
    flowType: 'quote',
    id: dto.quoteId,
    quoteId: dto.quoteId,
    riskId: dto.riskId || riskId,
    folderIdentifier: dto.folderIdentifier || folderIdentifier,
    tunnelId: dto.tunnelId,
    statusCode: dto.statusCode,
    quoteTabs: dto.quoteTabs,
    productOwner: dto.productOwner,

    // Statuts (calcules par le backend)
    statusCategory: dto.statusCategory,
    statusSeverity: dto.statusSeverity,
    contractSignatureStatus: dto.contractSignatureStatus,
    mandateSignatureStatus: dto.mandateSignatureStatus ?? null,
    requiresOwnMandate: dto.requiresOwnMandate,
    cabinetMandate: dto.cabinetMandate ?? null,
    hasCertificate: dto.hasCertificate,

    // Statuts des cartes UI
    cardStatuses: dto.cardStatuses,

    // Permissions
    permissions: dto.permissions,
    disabledReasons: dto.disabledReasons,

    // Validation du devis
    validation: dto.validation ?? null,

    // Donnees metier
    insured: dto.insured,
    groupContractIdentifier: dto.groupContractIdentifier,
    isMaster: dto.isMaster,
    mandateId: dto.mandateId,
    branchCode: dto.branchCode || branchCode || (dto as any).type,
    pricing: dto.pricing,
    tenants: dto.tenants,
    realEstate: dto.realEstate,
    propertyCompleted: dto.propertyCompleted,
    isAnimationCompleted: dto.isAnimationCompleted,
    parc: dto.parc,
    parcRealEstates: dto.parcRealEstates,
    copropertyId: dto.copropertyId,
    coproperty: dto.coproperty,
    copropertyCompleted: dto.copropertyCompleted,
    copropertyClaimsHistoryCompleted: dto.copropertyClaimsHistoryCompleted,
    copropertyClaimsDocumentRequired: dto.copropertyClaimsDocumentRequired,
    surveyAnswers: dto.surveyAnswers,
    company: dto.company
  };
};

/**
 * Verifie si les donnees de contractualisation sont de type Quote
 * (et non Borrower)
 */
export const isQuoteContractualizationResponse = (
  data: unknown
): data is ContractualizationResponseDto => {
  return (
    data !== null &&
    typeof data === 'object' &&
    'quoteTabs' in data &&
    !('process' in data)
  );
};
